import ViewQuizDetailsButton from '../ViewQuizDetailsButton/ViewQuizDetailsButton';
import styles from './QuizResultsArea.module.css';

const formatDate = (rawDate) => {
  const date = new Date(Number(rawDate));
  return isNaN(date)
    ? 'N/A'
    : date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
};

const QuizResultsArea = ({ attempts }) => {
  return (
    <div className={styles.resultsArea}>
      <h2 className={styles.title}>Sports IQ Results</h2>
      <div className={styles.resultsList}>
        {attempts && attempts.length > 0 ? (
          attempts.map((attempt) => (
            <div key={attempt._id} className={styles.resultCard}>
              <div>
                <p><strong>Sport:</strong> {attempt.sport.charAt(0).toUpperCase() + attempt.sport.slice(1)}</p>
                <p><strong>Level:</strong> {attempt.level}</p>
                <p><strong>Score:</strong> {attempt.scorePercent}%</p>
                <p><strong>Date:</strong> {formatDate(attempt.dateTaken)}</p>
              </div>
              <ViewQuizDetailsButton attemptId={attempt._id} />
            </div>
          ))
        ) : (
          <p className={styles.noResults}>No assessments yet. Select a sport and level to test your knowledge.</p>
        )}
      </div>
    </div>
  );
};

export default QuizResultsArea;